import {
    NonprofitWrappers,
    NonprofitTitle,
    Causes,
    CausesTitle,
    CausesList,
    CausesItem,
    NonprofitDetails,
    TextHeading,
    ContentCol,
    ContentColSpan,
    DonorVolunteerBoxWrap,
    DonorTextHeading,
}from './nonProfitOverviewStyle';
import { MESSAGE } from '../../../utils/message';

const NonprofitOverview = ({detail}:any) => {
  return (
    <>
        <NonprofitWrappers className='non-profit-wrapper-box'>
             <NonprofitTitle>{MESSAGE.nonprofitOverview}</NonprofitTitle>
              
                <NonprofitDetails className='non-profit-details-text'>
                <Causes className='non-profit-causes'>
                    {detail?.causes && detail.causes.length > 0 && (
                      <>
                        <CausesTitle>Causes:</CausesTitle>
                        <CausesList>
                          {detail.causes.map((cause: any, index: number) => {
                            return (
                              <CausesItem key={index + 1}>
                                <a href={`/categories/view/${cause.slug}`} title={cause.slug}>
                                  {cause.title}
                                </a>
                              </CausesItem>
                            );
                          })}
                        </CausesList>
                      </>
                    )}

                  </Causes>
                    {detail?.mission && (
                      <>
                        <TextHeading>Mission:</TextHeading>
                        <ContentCol>{detail.mission}</ContentCol>
                      </>
                    )}
                    {detail?.results && (
                      <>
                        <TextHeading>Results:</TextHeading>
                        <ContentCol>{detail?.results}</ContentCol>
                      </>
                    )}
                    {detail?.target && (
                      <>
                        <TextHeading>Target demographics:</TextHeading>
                        <ContentCol>{detail?.target}</ContentCol>
                      </>
                    )}
                    {detail?.bens_direct && (
                      <>
                        <TextHeading>Direct beneficiaries per year:</TextHeading>
                        <ContentCol>{detail?.bens_direct}</ContentCol>
                      </>
                    )}
                    {detail?.areas && (
                      <>
                         <TextHeading>Geographic areas served:</TextHeading>
                         <ContentCol className='nepalcity'>{detail?.areas}</ContentCol>
                      </>
                    )}
                   {detail?.programs && (
                      <>
                         <TextHeading>Programs:</TextHeading>
                         <ContentCol>{detail?.programs}</ContentCol>
                      </>
                    )}
                   
               </NonprofitDetails>

               {/* <NonprofitDetails className='non-profit-details-text-two'>
                  <TextHeading>Causes:</TextHeading>
                  <ContentCol> <ContentColSpan>{detail?.causes?.map((cause:any, index:number) => (
                          <CausesItem key={index+1}>{cause?.title}</CausesItem>))}</ContentColSpan> </ContentCol>
                  <TextHeading>Mission:</TextHeading>
                  <ContentCol>{detail?.mission}</ContentCol>
               </NonprofitDetails> */}

        </NonprofitWrappers>

        <DonorVolunteerBoxWrap className='donor-volunteer-advisory-wrap'>
          <DonorTextHeading>DONOR & VOLUNTEER ADVISORY</DonorTextHeading>
          <ContentCol>This organization's nonprofit status may have been revoked or it may have merged with another organization or ceased operations.</ContentCol>
        </DonorVolunteerBoxWrap>
    </>
  )
}

export default NonprofitOverview
